<template>
  <GmbSticker
      class="gmb-individual-sticker"
      :text="safeCountRepr(individualCount)"
      :isLarge="isLarge"
  >
    <FdText fa fontSizeSmaller1><i class="fas fa-male"/></FdText>
  </GmbSticker>
</template>

<script>
import {NumberFormatter} from "@/helpers.js";

import FdText from "@/flexdesign/Text";

import GmbSticker from "@/widgets/Sticker";

export default {
  name: "GmbIndividualSticker",

  components: {
    FdText,
    GmbSticker,
  },

  props: {
    individualCount: [Number, String],
    isLarge: Boolean,
  },

  data() {
    return {};
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    safeCountRepr(item) {
      if (item == null) return "?";
      if (item > 999999)
        item = NumberFormatter.toLocalString(999999, "fr-FR") + "+";
      else item = NumberFormatter.toLocalString(item, "fr-FR");
      return item.toString();
    },
  },
};
</script>

<style lang="scss">
@import "@/sass/settings/colors";

/* =========================================================================
 * INDIVIDUAL STICKER
 * ========================================================================= */

.gmb-individual-sticker {
  background-color: $gmb-color-theme-3;
}
</style>
